import cjPontanegraApi from '../apis/cjPontanegraApi';

export const forgotPasswordsService = async (email: string): Promise<void> => {
  await cjPontanegraApi.post('/passwords/forgot', { email });
};
